import { render, staticRenderFns } from "./PreviousInvoices.vue?vue&type=template&id=3d1a7bec"
import script from "./PreviousInvoices.vue?vue&type=script&lang=js"
export * from "./PreviousInvoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d1a7bec')) {
      api.createRecord('3d1a7bec', component.options)
    } else {
      api.reload('3d1a7bec', component.options)
    }
    module.hot.accept("./PreviousInvoices.vue?vue&type=template&id=3d1a7bec", function () {
      api.rerender('3d1a7bec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/customers/PreviousInvoices.vue"
export default component.exports